import React, { useState } from "react"
import { Animated } from "react-native"

import { LOGIN_TRANSITION_DURATION } from "./AuthModal"

export function useTransitionInAndOut({
  transitionOnEnter,
  transitionOut,
  side,
}: {
  side: "left" | "right"
  transitionOnEnter: boolean
  transitionOut: boolean
}) {
  const animation = useState(new Animated.Value(transitionOnEnter ? 0 : 1))[0]
  const opacity = animation.interpolate({ inputRange: [0, 1, 2], outputRange: [0, 1, 0] })
  const translateStops = side === "left" ? [-20, 0, -20] : [20, 0, 20]
  const translate = animation.interpolate({ inputRange: [0, 1, 2], outputRange: translateStops })
  const height = animation.interpolate({ inputRange: [0, 1, 2], outputRange: [0, 44, 0] })

  const mounted = React.useRef(false)
  React.useEffect(() => {
    mounted.current = true
  }, [])

  if (!mounted.current) {
    Animated.timing(animation, {
      toValue: 1,
      useNativeDriver: true,
      duration: LOGIN_TRANSITION_DURATION,
    }).start()
  }

  if (transitionOut) {
    Animated.timing(animation, {
      toValue: 2,
      useNativeDriver: true,
      duration: LOGIN_TRANSITION_DURATION,
    }).start()
  }

  return { opacity, translate, height }
}
